var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764_16690)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 20,
    height: 14,
    rx: 2,
    fill: "#CACBCC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.761628,
    height: 25.9242,
    rx: 0.380814,
    transform: "matrix(0.503481 0.864006 -0.694509 0.719484 18.6299 0)",
    fill: "#F42222"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.761628,
    height: 25.9242,
    rx: 0.380814,
    transform: "matrix(0.503481 0.864006 -0.694509 0.719484 18.6299 0)",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_764_16690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEqual);
export default __webpack_public_path__ + "static/media/NotEqual.81d16873b7bc4ed4eeb94417d8b595a6.svg";
export { ForwardRef as ReactComponent };